import * as React from 'react';
import { IComboBox, IComboBoxOption, VirtualizedComboBox } from "@fluentui/react";
import { FormEvent, useEffect, useState } from "react";

interface IComboBoxComponent {
    text: string;
    required?: boolean;
    data: IComboBoxOption[];
    disable?: boolean;
    placeholder?: string;
    width?: string;
    loading?: boolean;
    onChange?: (value: string) => void;
    onOptionSelect?: (
        event: FormEvent<IComboBox>, option?: IComboBoxOption | undefined
    ) => void;
    defaultSelectedOptions?: IComboBoxOption[];
    onRender?: (data: any) => JSX.Element | undefined;
    KeyUp?: React.KeyboardEventHandler<IComboBox> | undefined;

}
interface ISelectedOptions {
    text: string;
    key: string | number;
}
export const ComboBoxComponent = (props: IComboBoxComponent) => {
    const [value, setValue] = useState<string>("");
    const [dataSeleccionada, setDataSeleccionada] = useState<ISelectedOptions[]>([]);
    const [isOptionSelected, setIsOptionSelected] = useState(false);
    useEffect(() => {
        if (
            props.defaultSelectedOptions &&
            props.defaultSelectedOptions.length > 0
            //&& !isOptionSelected
        ) {
            setDataSeleccionada(props.defaultSelectedOptions);
            setValue(props.defaultSelectedOptions[0]?.text || "");
        } else {
            setDataSeleccionada([]);
        }
    }, [props.defaultSelectedOptions]);
    const handleInputChange = (
        text: string
    ) => {
        setValue(text);
        setIsOptionSelected(false);
        if (props.onChange) props.onChange(text);
    };
    useEffect(() => {
        if (isOptionSelected) {
            const dat = dataSeleccionada.map((x) => x.text).join(", ");
            setValue(dat);
        }
    }, [dataSeleccionada]);
    const onSelect = (event: FormEvent<IComboBox>, option?: IComboBoxOption | undefined) => {
        if (option) {
            const opcion: ISelectedOptions = {
                text: option.text,
                key: option.key,
            };
            setDataSeleccionada([opcion]);
            setValue(opcion.text);
            setIsOptionSelected(true);
            if (props.onOptionSelect) props.onOptionSelect(event, opcion);
        }
    }

    return (
        <div
            style={{
                width: props.width == null ? "100%" : props.width,
                minWidth: "100px",
                marginTop: "20px",
                display: "flex",
                flexDirection: "column",
            }}
        >

            <VirtualizedComboBox options={props.data}
                label={props.text}
                selectedKey={dataSeleccionada[0]?.key}
                disabled={props.disable == null ? false : props.disable}
                allowFreeform
                onChange={onSelect} onInputValueChange={handleInputChange}
                autoComplete="on"
                placeholder={props.placeholder}
                useComboBoxAsMenuWidth errorMessage={props.required ? (value !== "" && value != undefined
                    ? undefined
                    : `El campo ${props.text} es requerido.`) : undefined}
                    onKeyUp={props.KeyUp}
            />
        </div>



    )


}
